import {
  callApi,
  deleteRequest,
  getRequest,
  handleError,
  handleResponse,
  postRequest,
} from '@helpers/api';
import { keysToCamel } from '@helpers/camelCaseConverter';

export * from './gameChanger';

const listGameChangerOutputFile =
  agent =>
  ({ entityId, yearStart, monthStart, yearEnd, monthEnd, limit = 1, offset }) =>
    agent.get(
      `vFile/gameChangerOutputFile/list/${entityId}/?year_start=${yearStart}&month_start=${monthStart}&year_end=${yearEnd}&month_end=${monthEnd}&limit=${limit}&offset=${offset}`
    );

const amazonCentralPullTransactions =
  agent =>
  ({ entityId, year, month }) =>
    agent.post(`vFile/amazonSellerCentralPull/${entityId}/${year}/${month}/`);

const downloadGameChangerFile =
  agent =>
  ({ id }) =>
    agent.get(`vFile/gameChangerFile/${id}/`);

const amazonSellerCentralRequestApi =
  agent =>
  ({ entityId, year, month }) =>
    agent.get(`vFile/amazonSellerCentralRequest/${entityId}/${year}/${month}/?limit=1000`);

const createAmazonTransactionsToXlsFilesFormatApi =
  agent =>
  ({ entityId, year, month, listCountriesIsoDistanceSellingDestination }) =>
    agent.post(
      `vFile/amazonTransactionsToGameChangerOutputFile/${entityId}/${year}/${month}/`,
      listCountriesIsoDistanceSellingDestination || {}
    );

const listGameChangerOutputRequestApi =
  agent =>
  ({ entityId }) =>
    agent.get(`vFile/gameChangerOutputRequest/list/${entityId}/`);

const readGameChangerOutputFileApi =
  agent =>
  ({ id }) =>
    agent.get(`vFile/gameChangerOutputFile/${id}/`);

const deleteGameChangerOutputFileRequestApi =
  agent =>
  ({ id }) =>
    agent.delete(`vFile/gameChangerOutputFile/${id}/`);

const periodsDateDueApi =
  agent =>
  ({ from, to }) =>
    agent.get(`vFlow/periodsDateDue/${from}/${to}/`);

const postGamechangerOutputFilesApi =
  agent =>
  ({ outputFiles, templateId }) =>
    agent.post(
      `vFile/standardTemplateGamechangerOutputFiles/?standard_template=${templateId}`,
      outputFiles
    );

export const getListGameChangerOutputFiles = async payload =>
  callApi(listGameChangerOutputFile)(payload).then(handleResponse).catch(handleError);

export const amazonCentralPull = async payload =>
  callApi(amazonCentralPullTransactions)(payload)
    .then(response => keysToCamel(response))
    .catch(error => error);

export const downloadGameChangerFileRequest = async payload =>
  callApi(downloadGameChangerFile)(payload).then(handleResponse).catch(handleError);

export const amazonSellerCentralRequest = async payload =>
  callApi(amazonSellerCentralRequestApi)(payload).then(handleResponse).catch(handleError);

export const createAmazonTransactionsToXlsFilesFormat = async payload =>
  callApi(createAmazonTransactionsToXlsFilesFormatApi)(payload)
    .then(handleResponse)
    .catch(handleError);

export const listGameChangerOutputRequest = async payload =>
  callApi(listGameChangerOutputRequestApi)(payload).then(handleResponse).catch(handleError);

export const readGameChangerOutputFile = async payload =>
  callApi(readGameChangerOutputFileApi)(payload).then(handleResponse).catch(handleError);

export const deleteGameChangerOutputFileRequest = async payload =>
  callApi(deleteGameChangerOutputFileRequestApi)(payload).then(handleResponse).catch(handleError);

export const periodsDateDue = async payload =>
  callApi(periodsDateDueApi)(payload).then(handleResponse).catch(handleError);

export const postGamechangerOutputFiles = async payload =>
  callApi(postGamechangerOutputFilesApi)(payload).then(handleResponse).catch(handleError);

/**
 * Delete game changer file
 * @param {string} id Id of file to delete
 * @returns {Promise<*>}
 */
export const deleteGameChangerFile = id => deleteRequest(`vFile/gameChangerFile/${id}/`);

/**
 * Lists GC output files
 * @param {string} templateId - selected template id
 * @returns {Promise<*>}
 */
export const listOutputFileIds = ({ templateId }) =>
  getRequest(`vFile/standardTemplateGamechangerOutputFiles/${templateId}/`);

/**
 * Delete GC output file
 * @param {string} templateId - selected template id
 * @param {Object<{templateId: string, gameChangerOutputFilesUnAssignList: Array<string>}>} outputFile - output file list.
 * @returns {Promise<*>}
 */
export const deleteOutputFileRequest = ({ templateId, outputFiles }) =>
  deleteRequest(`vFile/standardTemplateGamechangerOutputFiles/${templateId}/`, {
    game_changer_output_files_un_assign_list: outputFiles,
  });

/**
 * Create game changer file
 * @param {Object} payload
 * @param {string} payload.entity Entity ID
 * @param {string} payload.key Uploaded file key
 * @param {string} payload.file_type Uploaded file type
 * @param {string} payload.year Transaction year
 * @param {string} payload.month Transaction month
 * @returns {Promise<*>}
 */
export const createAmazonGameChangerFile = payload =>
  postRequest('vFile/gameChangerFile/', payload);
